export default __webpack_public_path__ + "static/media/folder.d2f311c6.svg";